module.exports = __webpack_public_path__ + "img/TOP.6bdd9b78.png";